<template>
  <div>
 
 
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
   
	
	
 <tabs pills icons centered tab-content-classes="tab-space">
	<tab-pane id="home" key="home">
	  <span slot="title">
		 <!-- <i class="nc-icon nc-umbrella-13"></i> --> Task - Main
	  </span>
	
	

    <h4 v-if="createForm" >
      Add A New Task
    </h4>
     <h4 v-else>
     <span v-if="model.task_name_sys=='agm'">AGM Task<br/></span>
     <span v-if="model.task_name_sys=='ar'">AR Task<br/></span>
      <span v-if="model.task_name_sys=='sc'">Share Certificate Task</span>
     <span v-else style="font-weight:bold;">Task Details</span>
    </h4>
    
	
 <card class="form-horizontal">
 
 	<div class="row" style="text-align:left;margin-bottom:18px;">
      <label class="col-sm-2 col-form-label">Task ID</label>
      <div class="col-sm-7" style="font-weight:bold;padding-top:7px">
     
     	{{model.id}}
        	
        	
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
   
    <div class="row" style="text-align:left;;">
      <label class="col-sm-2 col-form-label">Task Name</label>
      <div class="col-sm-7" style="">
     
     		 <fg-input type="text"
                  name="task_name"
                  v-validate="modelValidations.task_name"
                  data-vv-scope="taskMain"
                  :error="getErrorCs('task_name','taskMain')"
                  v-model="model.task_name">
        	</fg-input>
        	
        	
        	<p-button  v-if="0"  @click="goToUpdateShareCert()" type="info">
           				Update Share Certificate</p-button> 
        	
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
    
    
    
    <div v-if="displaySt" class="row" style="text-align:left;padding:10px 0px;" @click.prevent="goToEditShareTransaction">
      <label class="col-sm-2 col-form-label">Transaction Details</label>
      <div class="col-sm-7" style="padding:9px 5px;padding-left:20px;">
     {{model.st.transaction_type_str}}: {{model.st.num_shares}}  {{model.st.share_type_str}} Shares FOR  {{model.st.shareholder_name_str}} 
     <a href="#">(View Details)</a>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    <div v-if="displayStt" class="row" style="text-align:left;padding:10px 0px;" >
      <label class="col-sm-2 col-form-label">Transaction Details</label>
      <div class="col-sm-7" style="padding:9px 5px;padding-left:20px;">
     {{model.st.transaction_type_str}}: {{model.st.num_shares}}  {{model.st.share_type_str}} Shares  {{model.st.transaction_desc}} 
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div v-if="displayOc" class="row" style="text-align:left;padding:10px 0px;" @click.prevent="goToEditOfficerChange">
      <label class="col-sm-2 col-form-label">Officer Change</label>
      <div class="col-sm-7" style="padding:9px 5px;padding-left:20px;">
     {{model.oc.officer_name_str}}: {{model.oc.new_officer_status_str}} 
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
    <div v-if="displaySc" class="row" style="text-align:left;padding:10px 0px;">
      <label class="col-sm-2 col-form-label">Share Certificate No: {{model.sh.cert_num}}</label>
      <div class="col-sm-7" style="padding:9px 5px;padding-left:20px;">
     {{model.sh.shareholder_name_str}} holds  {{model.sh.num_shares}}  {{model.sh.share_type_str}} Shares   
     
     
      <p-button v-if="model.task_status==4 && displaySc && !model.sh.cancel_task_id"  @click.prevent="goToCreateTaskDetailsForCancelCsNewTask" style="margin-left:20px;">Cancel This Share Certificate</p-button>
      <p-button v-if="model.task_status==4 && displaySc && model.sh.cancel_task_id"  @click.prevent="viewCancelScTask" style="margin-left:20px;">View Created Resolution To Cancel This Cert</p-button>

     
     
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
    
      <div v-if="displayScc" class="row" style="text-align:left;padding:10px 0px;">
      <label class="col-sm-2 col-form-label">Cancel Share Certificate No: {{model.sh.cert_num}}</label>
      <div class="col-sm-7" style="padding:9px 5px;padding-left:20px;">
     {{model.sh.shareholder_name_str}} holds  {{model.sh.num_shares}}  {{model.sh.share_type_str}} Shares   
     

      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
    
     <div class="row" v-if="model.task_name_sys=='sc'">
      <label class="col-sm-2 col-form-label">Effective Date Of Share Cert</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.sc_effective_date" type="date" placeholder="Select A Date"
                               >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
    
  
   <div v-if="displaySc && model.sh.sc_status==5" class="row" style="padding:20px 0px;">
      <label class="col-sm-2 col-form-label">Share Certificate Status</label>
      <div class="col-sm-7">
      <div style="font-weight:bold;font-size:16px;padding-top:7px;color:red;">Cancelled</div>
      </div>
    </div>
    
    <div v-if="displaySc && model.sh.sc_status==4" class="row" style="padding:20px 0px;">
      <label class="col-sm-2 col-form-label">Share Certificate Status</label>
      <div class="col-sm-7">
      <div style="font-weight:bold;font-size:16px;padding-top:7px;color:green;">Active</div>
      </div>
    </div>
		

	 <div v-if="model.sh.sc_status!=5" class="row" style="padding:20px 0px;">
      <label class="col-sm-2 col-form-label">Task Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select
                  			:disabled="disableStatus"
                  			class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="model.task_status">
                    <el-option v-for="option in selects.t_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
    </div>


  </card>
 <div style="font-size: 13px;margin-left: 15px;color: #333;">{{createdBy}}</div>
	
<div  style="min-height:60px;"></div>


	<div  v-if="!createForm" class="row">
		<div class="col-xl-12">
		<card v-if="model.task_type!=3" style="margin-top:20px;">
			 <div style="text-align:center;">
			<p-button    @click="goToResoBuilder()" type="danger" style="width:100%;padding:30px;">
				 <i slot="label" class="nc-icon nc-settings-gear-65"></i>
								Edit via Task Builder
			</p-button> 
			</div>

		</card>
		</div>

	</div>
	
	

	
	
<div v-if="!createForm && model.task_type!=3" style="margin-top:20px;">
 <h4 slot="header" class="card-title" style="font-weight:bold;">
     Changes & Resolution Items
    </h4>
</div>
    
    <card  v-if="!createForm && model.task_type!=3">
    
	<div v-if="!createForm" style="margin-bottom:30px;margin-top:0px;">
      <div class="">
            	 
      	  <div><p class="text-muted">* Only update the items below to "Completed" if you wish to execute the stated change(s). 
      	   Once executed, the company's records will be updated accordingly.</p></div>
      	 <el-table :data="cr" style="text-align:center;">
                <el-table-column label="Type" width="250" >
                		<template slot-scope="scope" >
           				 <span v-if="scope.row.type=='change_officer'">Change: Officer</span>
           				  <span v-if="scope.row.type=='change_member'">Change: Member</span>
           				  <span v-if="scope.row.type=='change_member_company'">Change: Member (Company)</span>
           				 <span v-if="scope.row.type=='change_shareholder'">Change: Shares</span>
           				 <span v-if="scope.row.type=='change_coy_info'">Change: Company Details</span>
						<span v-if="scope.row.type=='change_share_cert'">Change: Share Certificate</span>
						<span v-if="scope.row.type=='reso_items'">Custom Resolution Item</span>
						<span v-if="scope.row.type=='share_cert'">Share Certificate</span>
          			</template>                
                </el-table-column>
                
				<el-table-column label="Description"  >
                		<template slot-scope="scope" >
                		
                		<span v-if="scope.row.type=='reso_items'">           				 
           				 	 {{scope.row.data.text}}
           				 </span>
           				 
           				 <span v-if="scope.row.type=='share_cert'">           				 
           				 	Share Certificate #{{scope.row.data.cert_number}}
           				 </span>
           				 
           				 
                		
           				 <span v-if="scope.row.type=='change_officer'">
           				 	 <span v-if="scope.row.data.officer_status==1">Appointment Of Officer:</span>
           				 	 <span v-if="scope.row.data.officer_status==2">Resignation Of Officer:</span>
           				 
           				 	 {{scope.row.data.person.first_name}}  {{scope.row.data.person.last_name}} ( {{scope.row.data.person.gov_id}})
           				 	 
           				 	  <span v-if="scope.row.data.new_officer_position==3">(Secretary)</span>
           				 	   <span v-if="scope.row.data.new_officer_position==1 || scope.row.data.new_officer_position==2">(Director)</span>
           				 	 
           				 	 
           				 	 
           				 </span>
           				 
           				 
           				  <span v-if="scope.row.type=='change_member'">
           				 	 <span v-if="scope.row.data.member_status==1">Appointment Of Member:</span>
           				 	 <span v-if="scope.row.data.member_status==2">Resignation Of Member:</span>
           				 
           				 	 {{scope.row.data.person.first_name}}  {{scope.row.data.person.last_name}} ( {{scope.row.data.person.gov_id}})
           				 </span>
           				 
           				 
           				 
           				   <span v-if="scope.row.type=='change_member_company'">
           				 	 <span v-if="scope.row.data.member_status==1">Appointment Of Member:</span>
           				 	 <span v-if="scope.row.data.member_status==2">Resignation Of Member:</span>
           				 
           				 	 {{scope.row.data.company_info.company_name}}  ({{scope.row.data.company_info.company_reg_num}})
           				 </span>
           				 
           				 
           				 <span v-if="scope.row.type=='change_share_cert'">
           				 	 <span v-if="scope.row.data.type==1">Issue</span>
           				 	 <span v-if="scope.row.data.type==2">Cancel</span>
           				  Share Certificate #{{scope.row.data.share_cert.cert_number}}
           				 	
           				 </span>
           				 
           				 
           				  <span v-if="scope.row.type=='change_shareholder'">
           				 	 
           				 	  {{scope.row.data.num_shares}} 
           				 	    <span v-if="scope.row.data.share_type==1">Ordinary</span>
								  <span v-if="scope.row.data.share_type==2">Preference</span>
								  <span v-for="st in scope.row.data.share_types">
									  <span v-if="scope.row.data.share_type==st.id">{{st.name}}</span>
								  </span>
							  
           				 	   Shares
           				 	  ({{scope.row.data.paid_up_capital}} {{scope.row.data.currency}})
           				     <span v-if="scope.row.data.transaction_type==3">
								From 	
								<span v-if="scope.row.data.company_info2">
								
									{{scope.row.data.company_info2.company_name}}  ({{scope.row.data.company_info2.company_reg_num}} )
								
								</span>
								
								<span v-else> {{scope.row.data.person2.first_name}}  {{scope.row.data.person2.last_name}} ( {{scope.row.data.person2.gov_id}})</span>
           				 	 </span>
							To:  
							
								<span v-if="scope.row.data.company_info">
								
									{{scope.row.data.company_info.company_name}}  ({{scope.row.data.company_info.company_reg_num}} )
								
								</span>
           				 	<span v-else>  {{scope.row.data.person.first_name}}  {{scope.row.data.person.last_name}} ( {{scope.row.data.person.gov_id}}) </span>
           				 </span>
           				
           				
           				<!-- change: coy info--> 
           				 <span v-if="scope.row.type=='change_coy_info'">
           				 	 <span v-if="scope.row.data.ch_type=='ch_coy_fye'">
           				 	 	Financial Year-end Date Change To:
           				 	 	{{scope.row.data.date_field_1_str}} 
           				 	 </span>
           				 	 
           				 	 
           				 	  <span v-if="scope.row.data.ch_type=='ch_coy_activity'">
								<span v-if="scope.row.data.str_field_1">Primary Activity Change To: ({{scope.row.data.str_field_1}}) {{scope.row.data.str_field_2}}<br/> </span>
								<span v-if="scope.row.data.str_field_4">Secondary Activity Change To: ({{scope.row.data.str_field_4}}) {{scope.row.data.str_field_5}}</span>
           				 	 </span>
           				 	 
           				 	 
           				 	 <span v-if="scope.row.data.ch_type=='ch_coy_name'">
           				 	 	Company Name Change To:
           				 	 	{{scope.row.data.str_field_1}} 
           				 	 </span>
           				 	 
           				 	 <span v-if="scope.row.data.ch_type=='ch_address'">
           				 	 	Company Address Change To:
           				 	 	{{scope.row.data.str_field_1}} 
           				 	 </span>
           				 	 
           				 	 
           				 	  <span v-if="scope.row.data.ch_type=='ch_strike_off'">
           				 	 	Striking-off Of Company
           				 	 </span>
           				 	 
           				 </span>
      
           				 
           				<!-- end: change: coy info--> 

          			</template>                
                </el-table-column>
                
                 <el-table-column label="Status" width="150" >
                		<template slot-scope="scope" >
           				 <span v-if="scope.row.data.status==1"><i style="color:orange;font-size:24px;" class="nc-icon nc-sound-wave"></i></span>
						<span v-if="scope.row.data.status==4"><i style="color:green;font-size:24px;" class="nc-icon nc-check-2"></i></span>
						<span v-if="scope.row.data.status==5"><i style="color:red;font-size:24px;" class="nc-icon nc-simple-remove"></i></span>
							<span v-if="scope.row.type=='reso_items'">-</span>
          			</template>                
                </el-table-column>
                 <el-table-column label="View" width="350" >
                		<template slot-scope="scope" >
           				 <span v-if="scope.row.type=='change_officer'">
           				 		<p-button type="success" size="sm" icon @click="goToOfficerChange(scope.row)">
                 			 		<i class="fa fa-edit"></i>
                				</p-button>
           				 </span>
           				 
           				 <span v-if="scope.row.type=='change_member'">
           				 		<p-button type="success" size="sm" icon @click="goToMemberChange(scope.row)">
                 			 		<i class="fa fa-edit"></i>
                				</p-button>
           				 </span>
           				 
           				 <span v-if="scope.row.type=='change_member_company'">
           				 		<p-button type="success" size="sm" icon @click="goToMemberChange(scope.row)">
                 			 		<i class="fa fa-edit"></i>
                				</p-button>
           				 </span>
           				
           				 <span v-if="scope.row.type=='change_shareholder'">
           				 	<p-button type="success" size="sm" icon @click="goToShareTransaction(scope.row)">
                 			 <i class="fa fa-edit"></i>
                			</p-button>
           				 </span>
           				
           				 <span v-if="scope.row.type=='change_coy_info'">
           				 	<p-button type="success" size="sm" icon @click="goToChangeCompanyInfo(scope.row)">
                 			 <i class="fa fa-edit"></i>
                			</p-button>
           				 </span>
						
						
						<span v-if="scope.row.type=='change_share_cert'">
							<p-button type="success" size="sm" icon @click="goToEditChangeShareCert(scope.row)">
                 			 <i class="fa fa-edit"></i>
                			</p-button>
						</span>
						
						<span v-if="scope.row.type=='reso_items'">Custom Resolution Item</span>
						
						<span v-if="scope.row.type=='share_cert'">
							<p-button type="success" size="sm" icon @click="goToShareCert(scope.row)">
                 			 <i class="fa fa-edit"></i>
                			</p-button>
						</span>
          			</template>                
                </el-table-column>
                
        </el-table>

      	

      

            
      </div>
 
    </div>
    


  </card>
  
  
 <div  v-if="!createForm"  style="margin-top:70px;">
 <h4 slot="header" class="card-title" style="font-weight:bold;">
   <span v-if="model.task_type!=3"> Task Builder Generated Document</span>
   <span v-else>Main Document</span>
    </h4>
</div>
    
  <card  v-if="!createForm" >
  <div><p class="text-muted">* All signed documents are visible to the client.</p></div>
  <el-table :data="main_document" style="text-align:center;">
                <el-table-column label="Document Name" property="document_name" width="400" ></el-table-column>
                <el-table-column label="Uploaded On" property="uploaded_at_str"></el-table-column>
                <el-table-column label="Uploaded By" property="uploaded_by_str"></el-table-column>
                <el-table-column label="Signing Status"  >
                		<template slot-scope="scope" >
           				 <span v-if="scope.row.signing_status=='vi'">Viewed By Signers</span>
           				 <span v-if="scope.row.signing_status=='se'">Sent For Signing</span>
           				 <span v-if="scope.row.signing_status=='si'">Signing Complete</span>
           				 <span v-if="scope.row.signing_status=='co'">Processing Document For Signing</span>
           				 <span v-if="!scope.row.signing_status"> - </span>
          			</template>                
                </el-table-column>
                
                 <el-table-column label="E-Signing" width="150" >
                		<template slot-scope="scope">
           					<div v-if="model.main_document==scope.row.id && model.task_type!=3">
				
							<p-button v-if="scope.row.format=='pdf'"  @click="viewResoSigning" type="danger">E-Signing</p-button> 
							</div>
				
							<div v-else >
							<p-button v-if="scope.row.format=='pdf'"  @click="viewDocuSigning(scope.row.id)" type="danger">E-Signing</p-button> 
							</div>
          			</template>                
                </el-table-column>
                
                <el-table-column label="View"  >
                		<template slot-scope="scope">
           					<div v-if="model.main_document==scope.row.id && model.task_type!=3">								
								<p-button type="success" size="sm" icon @click="viewDocument(scope.row.id)">
                 			 			<i class="fa fa-edit"></i>
                				</p-button>
				
							</div>
				
							<div v-else >
							<p-button outline  @click="viewDocument(scope.row.id)" type="default">View</p-button> 
							</div>
          			</template>                
                </el-table-column>
                
        </el-table>
  
  </card>
  
  
  <!--<p-button  @click="generateNoticeAGM" type="danger">Generate Notice For AGM</p-button> -->
    
  
  
  <div style="margin-top:100px;">
 <h4 slot="header" class="card-title" style="font-weight:bold;">
    Additional Details
    </h4>
</div>
    
  
   <card class="form-horizontal">


    <div class="row"  v-if="model.task_name_sys!='ar'">
       <label v-if="model.task_name_sys=='agm'" class="col-sm-2 col-form-label">AGM Deadline</label>
       <label v-else class="col-sm-2 col-form-label">Deadline</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker  
              	:disabled="model.task_name_sys=='agm'" 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.deadline_date" type="date" placeholder="Select A Date"
                              v-validate="modelValidations.deadline_date" >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
       <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="emptyDeadline()"></span>
      </div>
    </div>
    
    <div class="row" v-if="model.task_name_sys!='ar'">
      <label class="col-sm-2 col-form-label">Scheduled Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.schedule_date" type="date" placeholder="Select A Date"
                              v-validate="modelValidations.schedule_date" >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
    	 <span style='font-size:#ccc;text-decoration:underline;font-size:11px;cursor:pointer;' @click="emptyScheduleDate()"></span>
      </div>
    </div>
    
    
    
     <div class="row" >
      <label class="col-sm-2 col-form-label">Filing/Completion Date</label>
      <div class="col-sm-7">
       	   <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.filed_datetime" type="date" placeholder="Select A Date"
                              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
      </div>
    </div>
	
	</card>
	
	
	<card class="form-horizontal">
	<div v-if="" class="row" style="padding:20px 0px;">
      <label class="col-sm-2 col-form-label">Payment Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select
                  			class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="model.payment_status">
                    <el-option v-for="option in selects.payment_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
    </div>

	
	<div class="row" style="padding-bottom:50px;">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
      		 <div style="overflow-x:scroll;">
       	  	<textarea 
        		 cols="75" rows="10"
                  name="new_reso_item"
                  v-model="model.notes">
       	 </textarea>
       	 </div>
       	<span style="font-size:11px;"><i> * Add your notes, ACRA transaction code, etc.</i></span>
      </div>
      <div class="col-sm-3 label-on-right">
      
      </div>
    </div>
    
    </card>
    
    
      <div v-if="!createForm" style="margin-top:100px;">
 <h4 slot="header" class="card-title" style="font-weight:bold;">
     Additional Task Documents
    </h4>
</div>
    
    <card >
    
	<div v-if="!createForm" style="margin-bottom:30px;margin-top:50px;">
      <div class="">
            	
      
      <!--	<div  v-if="documents">
      		<div v-for="doc in documents">
      			
      			<div v-if="model.main_document==doc.id && model.task_type!=3">
      			<p-button  outline  @click="viewDocument(doc.id)" type="default">Resolution PDF</p-button>
      			
      			
           		<p-button   @click="viewResoSigning" type="danger">E-Signing</p-button> 
      			</div>
      			
      			<div v-else >
      			<p-button outline  @click="viewDocument(doc.id)" type="default">{{doc.document_name}}</p-button> 
      			<p-button   @click="viewDocuSigning(doc.id)" type="danger">E-Signing</p-button> 
      			</div>
      			
      			
      		</div>
      	
      	</div>-->
      	<!--<div><p class="text-muted">* The documents below will not be visible to the client.</p></div>-->
      	 <el-table :data="documents" style="text-align:center;">
                <el-table-column label="Document Name" property="document_name" width="500" ></el-table-column>
                <el-table-column label="Uploaded On" property="uploaded_at_str"></el-table-column>
                <el-table-column label="Uploaded By" property="uploaded_by_str"></el-table-column>
                <el-table-column label="Signing Status" >
                		<template slot-scope="scope" >
           				 <span v-if="scope.row.signing_status=='vi'">Viewed By Signers</span>
           				 <span v-if="scope.row.signing_status=='se'">Sent For Signing</span>
           				 <span v-if="scope.row.signing_status=='si'">Signing Complete</span>
           				 <span v-if="scope.row.signing_status=='co'">Processing Document For Signing</span>
           				 <span v-if="!scope.row.signing_status"> - </span>
          			</template>                
                </el-table-column>
                
                 <el-table-column label="E-Signing" width="200" >
                		<template slot-scope="scope">
           					<div v-if="model.main_document==scope.row.id && model.task_type!=3">
				
							<p-button v-if="scope.row.format=='pdf'"  @click="viewResoSigning" type="danger">E-Signing</p-button> 
							</div>
				
							<div v-else >
							<p-button v-if="scope.row.format=='pdf'"  @click="viewDocuSigning(scope.row.id)" type="danger">E-Signing</p-button> 
							</div>
          			</template>                
                </el-table-column>
                
                <el-table-column label="View"  >
                		<template slot-scope="scope">
           					<div v-if="model.main_document==scope.row.id && model.task_type!=3">
							<p-button  outline  @click="viewDocument(scope.row.id)" type="default">Task Builder PDF</p-button>
				
				
							</div>
				
							<div v-else >
							<p-button outline  @click="viewDocument(scope.row.id)" type="default">View</p-button> 
							</div>
          			</template>                
                </el-table-column>
                
        </el-table>

      	

      
      
         <h4 >Upload Document</h4>
         
       <!-- start upload file-->
          <div class="upload_dropbox">
          <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" 
          @change="upload_filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
            accept="image/*, application/pdf" class="input-file-dropbox">
            <p v-if="isInitial">
              Drag a PDF or JPEG/PNG file here to upload<br> or click to browse
            </p>
            <p v-if="isSaving">
              Uploading {{ fileCount }} files...
            </p>
        </div>
        
        <!-- end upload file-->
            
      </div>
 
    </div>
    
    

    
    
    
    
 
  </card>
    

  
  
     <h4 style="font-weight:bold;margin-top:50px;">Actions</h4>
	<card>
			<i slot="label" class="nc-icon nc-settings-gear-65"></i>
		     <p-button v-if="createForm" type="info" @click.prevent="saveTask">Create Task</p-button>
      		<p-button v-else type="info" @click.prevent="editTask">   <i slot="label" class="nc-icon nc-settings-gear-65"></i>  Update This Task</p-button>
	
	</card>
  
  <div class="text-center">
 
      
      <div  v-if="model.task_status==1 && displaySt" style="margin:50px 0px;"> 
    	<p-button outline  round  @click="goToCreateTaskDetailsForSt()" type="info">
           				Send This Shares Resolution For Signing</p-button>
      </div>
       <div  v-if="model.task_status==1 && displayStt" style="margin:50px 0px;"> 
    	<p-button outline  round  @click="goToCreateTaskDetailsForStt()" type="info">
           				Send This Share Transfer For Signing</p-button>
      </div>
      
       <div  v-if="model.task_status==1 && displayOc" style="margin:50px 0px;"> 
    	<p-button outline  round  @click="goToCreateTaskDetailsForOc()" type="info">
           				Send This Officer Change For Signing</p-button>
      </div>
      
       <div  v-if="model.task_status==1 && displaySc" style="margin:50px 0px;"> 
    	<p-button outline   @click="goToCreateTaskDetailsForSc()" type="default">
           				Send This Share Certificate For Signing</p-button>           				 
      </div>
      
       <div  v-if="model.task_status==1 && displayScc" style="margin:50px 0px;"> 
    	<p-button outline   @click="goToCreateTaskDetailsForScc()" type="default">
           				Send This Resolution To Cancel The Share Cert For Signing</p-button>           				 
      </div>
      
    </div>
    
  
  
 	<div>
	<!-- <p-button v-if="!createForm" type="danger"  @click="deleteTask()" >-->
	<p-button v-if="0" type="danger"  @click="deleteTask()">
                <i slot="label" class="nc-icon nc-simple-remove"></i>
                Delete Task
     </p-button>
	</div>         
   </tab-pane>
   
   
   
   <tab-pane id="billing" key="billing"  v-if="!createForm">
	  <span slot="title">
		 Billing
	  </span>
	  
   
   	<div  v-if="!createForm" class="row">
		<div class="col-xl-12">
			<div >
				<h4 style="font-weight:bold;">Billing</h4>
			  </div>
			  <card v-if="current_invoice.id">
			  	<h5>Billing #{{current_invoice.id}} Created.</h5>
			  	<h5 v-if="current_invoice.status==1" style="color:red;font-weight:bold"">Not Paid</h5>
			  	<h5 v-if="current_invoice.status==2" style="color:green;font-weight:bold"">Paid</h5>
			  	<h5 v-if="current_invoice.status==3" style="color:orange;font-weight:bold"">N.A.</h5>
			  	<h5 v-if="current_invoice.status==4" style="color:orange;font-weight:bold"">Refunded</h5>
			  </card>
			  
			  <card v-if="!current_invoice.id">
			  	    <fg-input type="text" label="Item Name"
			  	    	v-model="new_invoice.item_name"
			  	    	data-vv-scope="invoice"
           			    name="item name"
           			    v-validate="'required'"
                 	   :error="getErrorCs('item name','invoice')"
                 	 
                 	 
			  	    	>
			  	    </fg-input>
			  	    
			  	     <fg-input type="text" label="Description"
			  	    	v-model="new_invoice.description"
           			    name="item description"
           			    placeholder="optional"
                 	 
			  	    	>
			  	    </fg-input>
			  	    
			  	    
			  	    
			  	    <fg-input type="text" label="Amount (SGD)"
			  	    	v-model="new_invoice.amount"
			  	    	v-validate="'required'"
			  	    	data-vv-scope="invoice" 
			  	    	name="amount"
			  	       :error="getErrorCs('amount','invoice')"
			  	    	
			  	    	>
			  	    </fg-input>
			  	     <p-button    @click="createInvoice" type="info" style="width:100%;">
           				Create Billing
   			 		</p-button> 
			  	    
			  </card>
		 </div>
	
	</div>
   
    </tab-pane>
      
 
	 
	 	<tab-pane v-if="crequest && !createForm" id="request" key="request">
	  <span slot="title">
		 <!-- <i class="nc-icon nc-umbrella-13"></i> -->Client's Request
	  </span>
	  
	  
	   <div>
	  	<h4 style="font-weight:bold;">Request</h4>
	  </div>
	  <card style="padding-top:20px;padding-bottom:20px;">
	   <div style="font-size:17px;"><strong>Request Status: <span> 
	   	<span v-if="crequest.status==1" style="color:orange;">Pending (In Progress)</span>
	   	 <span v-if="crequest.status==4" style="color:green;">Completed</span>
	   	 <span v-if="crequest.status==5">Cancelled</span>
	   </span></strong></div>
	   
	  <div style="font-size:17px;"><strong>Request Type:<span> {{crequest.type_str}}</span></strong></div>
	
	 
	  </card>
	  
	  <card>
	  	 <strong><span style="color:#000">Client wrote: </span></strong>&nbsp; <span style="white-space: pre;">{{crequest.description}}</span>
	  </card>
	  
	  
	  <div class="row">
	  
	  	<div class="col-xl-6">
	  	<h4   v-if="crequest.incorp_company && crequest.type=='5015'" style="font-weight:bold">Incorporation - Company Information</h4>
	  	<h4   v-if="crequest.incorp_company && crequest.type=='5016'" style="font-weight:bold">Appoint Us As Secretary - Company Information</h4>
	 	 <card v-if="crequest.incorp_company">
	 	 
	 	 <card style="text-align:center;">
	 	  <div>
	 		 <span style="font-size:22px;"><strong>Submission Status</strong></span><br/><br/>
	 		 <span style="color:green;font-size:17px;font-weight:bold;" v-if="crequest.incorp_company.details_form_status==4">
	 		 		Completed <br/> Client Has Indicated He/She Has Submitted All Details & Documents
	 		 </span>
	 		 <span style="color:red;font-size:17px;font-weight:bold;" v-else>Pending Client's Submission</span>
	 	 </div>
	 	 </card>
	 	 
	 	 <card v-if="!crequest.incorp_company.own_local_director  && crequest.type=='5015'">
			<span style="color:red"><strong>Using Nominee Director Service</strong></span>
	 	 </card>
	 	 
	 	  <card v-if="!crequest.incorp_company.own_address  && crequest.type=='5015'">
			<span style="color:red"><strong>Using Company Secretary's Address</strong></span>
	 	 </card>
	 	 
	 	 
	 	 <br/><br/>
	 	 
	 	 <div style="width:300px;margin-bottom:30px;margin-left:auto;margin-right:auto;">
	 	 	<p-button  v-if="crequest.incorp_company.details_form_status==4" 
	 	 		 @click.prevent="update_onboarding_form_editable" type="danger" style="width:100%;padding:10px 10px;font-size:13px">
           				Allow Client To Edit Form Again
   			 </p-button> 
   			 </div>
	 	 
	 	 
	 	  <div>
	 		 <span><strong>Client Portal Account's Email Address</strong></span><br/>
	 		 {{crequest.client.email}}
	 	 </div>
	 	 
	 	 <br/><br/>
	 	 
	 	 
	 	 <div>
	 		 <span v-if="crequest.type=='5015'"><strong>Preferred Company Name</strong></span>
	 		 <span v-if="crequest.type=='5016'"><strong>Company Name</strong></span>
	 		 <br/>
	 		 {{crequest.incorp_company.entity_name}}
	 	 </div>
	 	 
	 	 <br/><br/>
	 	 
	 	 <div>
	 		 <span><strong>Primary Activity</strong></span><br/> 
	 		 {{crequest.incorp_company.activity_1_code}} -  {{crequest.incorp_company.activity_1_title}} -  
	 		 <br/>{{crequest.incorp_company.activity_1_desc}}
	 	 </div>
	 	 
	 	 
	 	 <br/><br/>
	 	 
	 	 <div>
	 		 <span><strong>Secondary Activity</strong></span><br/> 
	 		 {{crequest.incorp_company.activity_2_code}} -  {{crequest.incorp_company.activity_2_title}} -  
	 		 <br/>{{crequest.incorp_company.activity_2_desc}}
	 	 </div>
	 	 
	 	 <br/><br/>
	 	  
	 	 <div>
	 		 <span><strong>Source Of Funds</strong></span><br/> 
	 		 <span v-for="s in crequest.incorp_company.sources_arr">{{s}} <br/></span>
	 	 </div>
	 	 
	 	 
	 	  <br/><br/>
	 	  
	 	 <div>
	 		 <span><strong>Company Address (Singapore)</strong></span><br/> 
	 		 <span v-if="!crequest.incorp_company.own_address && crequest.type=='5015'">
			<br/><span style="font-weight:bold;color:red;">Using Company Secretary's Address</span>
	 		 </span>
	 		 
	 		 {{crequest.incorp_company.address_1}} <br/>
	 		  {{crequest.incorp_company.address_2}} <br/>
	 		  {{crequest.incorp_company.zipcode}} <br/>
	 		  
	 		 
	 		   
	 	 </div>
	 	 
	 	 
	 	  <br/><br/>
	 	  
	 	 <div>
	 		 <span><strong>Address Of Principal Place Of Business (if different from above)</strong></span><br/> 
	 		 {{crequest.incorp_company.address_main_biz}} 
	 	 </div>
	 	 
	 	 
	 	  <br/><br/>
	 	  
	 	 <div>
	 		 <span><strong>Total Shares</strong></span><br/> 
	 		 {{crequest.incorp_company.total_shares}} 
	 	 </div>
	 	 
	 	 
	 	   <br/><br/>
	 	  
	 	 <div>
	 		 <span><strong>Total Paid-up Capital</strong></span><br/> 
	 		 {{crequest.incorp_company.total_paid_up_capital}}   {{crequest.incorp_company.currency}}
	 	 </div>
	 	
	  
	  </card>
	  </div> <!-- end left col -->
	  
	  
	  
	  </div> <!-- end row: incorp info-->
	  
	  
	  <div class="row"  v-if="crequest.incorp_company">
	  	<div class="col-xl-12">
	  		<h4 v-if="crequest.type=='5015'" style="font-weight:bold">Incorporation - Director(s)/Shareholder(s) Information</h4>
	  		<h4 v-if="crequest.type=='5016'" style="font-weight:bold">Director(s)/Shareholder(s) Information</h4>
	  	<card>
	   <el-table :data="crequest.incorp_people" >
                <el-table-column label="Position" property="document_name" min-width="140px" >
                	<template slot-scope="scope">
                	  <span v-if="scope.row.is_director">Director<br/></span>
					  <span v-if="scope.row.is_shareholder">Shareholder<br/></span>
					  <span v-if="scope.row.is_client">Client<br/></span>
                		</template>   
                </el-table-column>
                <el-table-column label="First Name" property="first_name" min-width="140px"></el-table-column>
                <el-table-column label="Last Name" property="last_name" min-width="140px"></el-table-column>
                <el-table-column label="Date Of Birth" property="dob" min-width="140px"></el-table-column>
                <el-table-column label="Email" property="email" min-width="220px"></el-table-column>
                <el-table-column label="Contact Number" property="contact_number" min-width="140px"></el-table-column>
                
                <el-table-column label="Govt ID Type" property="document_name" min-width="140px" >
                	<template slot-scope="scope">
                	  <span v-if="scope.row.gov_id_type==1">Government ID<br/></span>
					  <span v-if="scope.row.gov_id_type==2">Passport<br/></span>
                		</template>   
                </el-table-column>
              
                 <el-table-column label="Nationality" property="nationality" min-width="140px"></el-table-column>
				 <el-table-column label="Citizenship" property="document_name" min-width="140px" >
                	<template slot-scope="scope">
                	  <span v-if="scope.row.citizenship==1">Singapore Citizen<br/></span>
					  <span v-if="scope.row.citizenship==2">Singapore PR<br/></span>
					  <span v-if="scope.row.citizenship==3">Foreign Citizen<br/></span>
                		</template>   
                </el-table-column>
                
                 <el-table-column label="Gender" property="gender" min-width="140px"></el-table-column>
                 
                 <el-table-column label="Address Line 1" property="address_1" min-width="220px"></el-table-column>
                 <el-table-column label="Address Line 2" property="address_2"  min-width="140px"></el-table-column>
                 <el-table-column label="City" property="city"  min-width="140px"></el-table-column>
                <el-table-column label="Province" property="province"  min-width="140px"></el-table-column>
                <el-table-column label="Zipcode" property="zipcode"  min-width="140px"></el-table-column>
                <el-table-column label="Country Of Residence" property="address_country"  min-width="140px"></el-table-column>
                
        		<el-table-column label="Number Of Ordinary Shares" property="num_shares" min-width="140px" >
                	<template slot-scope="scope">
                	 	 <span v-if="scope.row.is_shareholder">{{scope.row.num_shares}}</span>
						 <span v-else>N.A.<br/></span>
                		</template>   
                </el-table-column>
                
                <el-table-column label="Paid-up Capital" property="paid_up_capital" min-width="140px" >
                	<template slot-scope="scope">
                	 	 <span v-if="scope.row.is_shareholder">{{scope.row.paid_up_capital}} SGD</span>
						 <span v-else>N.A.<br/></span>
                		</template>   
                </el-table-column>
	 			 
	 			 <el-table-column label="Politically Exposed Person (PEP)" property="has_pep" min-width="140px" >
                	<template slot-scope="scope">
                	 	 <span v-if="scope.row.has_pep">Yes</span>
						 <span v-else>No<br/></span>
                		</template>   
                </el-table-column>
                
                <el-table-column label="PEP Description (if applicable)" property="pep_description" min-width="140px" >
                	<template slot-scope="scope">
                	 	 <span v-if="scope.row.has_pep">{{scope.row.pep_description}}</span>
						 <span v-else>-<br/></span>
                		</template>   
                </el-table-column>
	 			 
	 			 
	 	
	 			 
	 			 
	 
	 			 
                
                
          
        </el-table>
	  	</card>
	  	
	  	</div>
	  </div>

	  	<div class="row" v-if="crequest.incorp_company && crequest.incorp_company.details_form_status==4">
	  		<div class="col-xl-6">
	  			<card v-if="cr.length==0">
	  				<p-button    @click.prevent="process_onboarding_people" type="danger" style="width:100%;padding:30px 10px;font-size:16px">
           				Confirm That Directors & Shareholders' Details Submitted By Client Are Correct
   					 </p-button> 
	  	
	  			</card>
	  			<card v-else gradient="success" style="padding:50px 50px;">
	  				<h5 style="font-size:18px;">Directors/Shareholders have been added to the People database. Changes have been created and added to this task.</h5>
	  			</card>
	  			
	  		</div>
	  	</div>
	  
	  
	  
	  
	  <div class="row">
	  <div class="col-xl-6">
	  <div style="margin-top:50px">
	  	<h4 style="font-weight:bold;">Request's Documents</h4>
	  </div>
	  <card>
	   <el-table :data="crequest.request_documents" style="text-align:center;">
                <el-table-column label="Document Name" property="document_name"  ></el-table-column>
                <el-table-column label="Uploaded On" property="created_at_str"></el-table-column>
                <el-table-column label="Uploaded By" property="created_by"></el-table-column>
                
                
                <el-table-column label="View"  >
                		<template slot-scope="scope">
    
				
							<div>
							<p-button outline  @click="viewRequestDocument(scope.row.id)" type="default">View</p-button> 
							</div>
          			</template>                
                </el-table-column>
                
        </el-table>
        </card>
        <card>
        <h5 style="font-weight:bold;">Upload Document</h5>
        	<input type="file" id="file" ref="new_file" class="btn btn-default" />
        	        	
        	
        	<p-button    @click.prevent="uploadFile()" type="info" style="width:100%;">
   				 <i slot="label" class="nc-icon nc-cloud-upload-94"></i>
           				Upload File
   			 </p-button> 
        </card>
        <!-- end documents-->
       </div>
         <div class="col-xl-6">
         
         	
         
         </div>
         </div><!-- end row--> 
        

	  	  <div style="margin-top:80px">
	  	<h4 style="font-weight:bold;">Request's Messages</h4>
	  </div>
	  <card>
	   <el-table :data="crequest.messages" style="text-align:center;">
                <el-table-column label="Message" property="message" >
                	<template slot-scope="scope" >
                	<span style="white-space: pre;">{{scope.row.message}}</span>
                	</template>
                </el-table-column>
                
                <el-table-column label="Sent By" property="created_by"></el-table-column>
                <el-table-column label="Sent On" property="created_at_str"></el-table-column>
                
         
                
        </el-table>
        </card>
        
        <card>
        <h5 style="font-weight:bold;">Send Message</h5>
          <div style="overflow-x:scroll;">
          <textarea  placeholder="Write a message to the client." rows="10"  cols="100"
          			 v-model="new_message.message"
           			 data-vv-scope="sendMsg"
           			 name="new message"
           			  v-validate="'required'"
                 	 :error="getErrorCs('new message','sendMsg')"
                 	   v-bind:class="{ field_error_cs: errors.has('new message','sendMsg') }"
          ></textarea>   <span class="invalid-feedback error-text" style="display:block;" v-if="errors.has('new message','sendMsg')">Please enter a message.</span>
          </div>
           <p-button    @click="sendMessage()" type="info" style="width:100%;">
   				 <i slot="label" class="nc-icon nc-send"></i>
           				Send
   			 </p-button> 
    
        </card>
        
        
        <!-- end messages-->
	  

	  
	   </tab-pane> 



</tabs>
	  

  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  const UPLOAD_STATUS_INITIAL = 0, UPLOAD_STATUS_SAVING = 1, UPLOAD_STATUS_SUCCESS = 2, UPLOAD_STATUS_FAILED = 3;
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	swal.showLoading();
     	this.onEditTaskLoad();
      	
      	
      
    },
    
     
    data () {
      return {
    	tid: this.$route.params.tid,
    	createForm: false,
    	coy:[],
    	pdfLink :'',
    	displaySt: false,
    	displaySc: false,
    	displayScc: false,
    	displayStt: false,
    	displayOc: false,
    	displayShareCert: false,
    	all_changes_completed: 2,
    	disableStatus: false,
    	main_document: [],
    	crequest:[],
    	current_invoice:[],
    	new_invoice:{
    		item_name:'',
    	},
    	new_message:{
    		message:'',
    	},
    	cr: [],
    	shareCert: '',
    	createdBy: '',
    	displayCustom: false,
    	documents: [],
        model: {
          task_type: '',
          task_name: '',
          task_name_sys: 1,
          task_status: 1,
          deadline_date: '',
          schedule_date: '',
          filed_datetime: '',
          sc_effective_date: '',
          created_datetime: '',
          entity_id: '',
          main_document:'',
          pdf_path:'',
          notes:'',
          payment_status:3,
          sh: {
          	sc_id:'',
          	cancel_task_id: '',
          	shareholder_name_str:'',
          	cert_num:'',
          	num_shares:'',
          	share_type_str:'',
          	sc_status:'',
          },
          st:{
          	num_shares:'',
          	transaction_type_str:'',
          	share_type_str:'',
          	shareholder_name_str:'',
          },
          oc:{
          	officer_name_str:'',
          	new_officer_status_str:'',
          	new_officer_position_str:'',
          }
         

        },
         uploadedFiles: [],
         uploadError: null,
         currentStatus: null,
         uploadFieldName: 'uploaded_documents',
          
        modelValidations: {
          deadline_date: {
          },
      
          task_status: {
            required: true,
          },
          task_name: {
            required: true,
          },
          schedule_date: {
          }
        },
        
        selects: {
          t_status: [
            {value: 1, label: 'Pending'},
            {value: 2, label: 'Waiting For Signature'},
            {value: 3, label: 'Signed'},
            {value: 4, label: 'Completed/Filed With ACRA'},
            {value: 5, label: 'Cancelled'},
		   ],
		  payment_status:[
            {value: 1, label: 'Paid'},
            {value: 2, label: 'Not Paid'},
            {value: 3, label: 'Not Applicable'},
		    {value: 4, label: 'Refunded'},
		   ],
        },
      }
    },
    computed: {
  
      isInitial() {
        return this.currentStatus === UPLOAD_STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === UPLOAD_STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === UPLOAD_STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === UPLOAD_STATUS_FAILED;
      }
    },
    methods:{
       goToShareTransaction(row){
      	  this.$router.push( '/create-share-transaction/'+row.data.id+'/entity/'+this.$route.params.eid+"/edit")  
        },
         goToEditChangeShareCert(row){
      	this.$router.push( '/edit-change-share-cert/'+row.data.id+'/entity/'+this.$route.params.eid)  
      },
       goToShareCert(row){
      	this.$router.push( '/view-share-cert/'+row.data.id+'/entity/'+this.$route.params.eid)
      },
       goToOfficerChange(row){
      	  this.$router.push( '/create-officer-change/'+row.data.id+'/entity/'+this.$route.params.eid+"/edit")  
      },
      goToMemberChange(row){
      	  this.$router.push( '/create-member-change/'+row.data.id+'/entity/'+this.$route.params.eid+"/edit")  
      },
      goToChangeCompanyInfo(row){
      	this.$router.push( '/edit-change-company-info/'+row.data.id+'/entity/'+this.$route.params.eid)  
      },
      
      generateNoticeAGM(){
      			swal.showLoading();
      			let uri = this.$base_url+'/api/v1/documents/generate/notice_agm/'+ this.$route.params.tid;
				 ApiService.get(uri).then(response => {
				 
				 		swal.close();
				 
				 })
      
      },
   
    	onEditTaskLoad(){
    		this.upload_reset();
			if(this.tid!=0){
				let uri = this.$base_url+'/api/v1/tasks/'+ this.$route.params.tid;
				 ApiService.get(uri).then(response => {
					this.createForm = false
					this.coy = response.data.entity;
					this.model = response.data.task;
					this.documents = response.data.documents;
					this.main_document = response.data.main_document;
					this.crequest = response.data.client_request;
					if(this.crequest){
						this.new_invoice.item_name = this.crequest.type_str;
						
					}
					if(response.data.invoice){
						this.current_invoice = response.data.invoice;
					}
					if(response.data.task.user){
						this.createdBy = "Task Created By: " + response.data.task.user.user_info.first_name + " " + response.data.task.user.user_info.last_name;
					}
					else{
						this.createdBy = "This is a request created by the client.";
					}
					
					
					if(response.data.task.task_name_sys == "agm" && response.data.task.task_status == 5){
						this.disableStatus = true;
					}
					
					if(response.data.task.task_name_sys == "ar" && response.data.task.task_status == 5){
						this.disableStatus = true;
					}
									
					if(this.model.task_name_sys == "st"){
						this.displaySt = true;
					}
					else if(this.model.task_name_sys == "stt"){
						this.displayStt = true;
					}
					else if(this.model.task_name_sys == "sc"){
						this.displaySc = true;
					}
					else if(this.model.task_name_sys == "scc"){
						this.displayScc = true;
					}
					else if(this.model.task_name_sys == "oc"){
						this.displayOc = true;
					}
					else if(this.model.task_name_sys == "multi"){
						this.displayCustom = true;
					}
				
					if(response.data.task.sc){
						this.shareCert = response.data.task.sc;
						this.displayShareCert = true;
					}
					
					this.cr = response.data.cr;
					this.all_changes_completed = response.data.all_changes_completed;
					
					swal.close();
				})//end resposne
			}
			else{
				this.createForm = true;
				let uri = this.$base_url+'/api/v1/entities/'+ this.$route.params.eid;
				 ApiService.get(uri).then(response => {
					
						this.coy = response.data.entity;
						swal.close();
			
				})
		
			}//end if-else
    	
    	},
    	/*makeKeyDoc(did){
    		let uri = this.$base_url+'/api/v1/documents/makekey/'+ did;
    		const vm = this;
			 ApiService.get(uri).then(response => {
					swal({
					  title: 'Done!',
					  text: 'The selected document is now the key document and can be sent for signing.',
					  type: 'success',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
					}).then(function(){
						let uri = vm.$base_url+'/api/v1/tasks/'+ vm.$route.params.tid;
						 ApiService.get(uri).then(response => {
	
							vm.documents = response.data.documents;
							vm.model.main_document = response.data.task.main_document;
				
				
			
						})//end resposne
					})
					//end swal
				
				
			
			})//end resposne
    
    },*/
    saveTask(){

    		
    		this.model.task_type = 3;
    		this.model.pdf_path = "";
    		this.model.entity_id = this.$route.params.eid;
    	
    		let uri = this.$base_url+'/api/v1/tasks';

			ApiService.post(uri, this.model).then(response => {
					
							this.$router.push( '/view-entity/'+this.$route.params.eid)
				
			})//end post
    	
    	
    }, //end saveTask()
    process_onboarding_people(){
    		let uri = this.$base_url+'/api/v1/tasks/onboarding/process_confirmed_onboarding_people/'+ this.crequest.id;
    		ApiService.get(uri).then(response => {
					
					this.$router.push( '/view-entity/'+this.$route.params.eid)
				
			})//end post
    
    
    },	
     update_onboarding_form_editable(){
     		swal.showLoading();
    		let uri = this.$base_url+'/api/v1/tasks/onboarding/update_onboarding_form_editable/'+ this.crequest.id;
    		const vm = this;
    		ApiService.get(uri).then(response => {
					   swal({
						  title: 'Success',
						  text: 'Client can update the form again.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.onEditTaskLoad();
						})
				
					
					
				
			})//end post
    
    
    },	
     goToResoBuilder(){
     	this.$router.push( '/resolution-builder/'+this.$route.params.tid+'/entity/'+this.$route.params.eid)  
     },
     goToUpdateShareCert(){
     	this.$router.push( '/view-share-cert/'+this.shareCert.id+'/entity/'+ this.coy.id)
     },
     viewResoSigning(){
     	this.$router.push( '/document-signing/'+this.$route.params.tid+'/entity/'+ this.coy.id+"/reso/0")
     },
     viewDocuSigning(did){
     	this.$router.push( '/document-signing/'+this.$route.params.tid+'/entity/'+ this.coy.id+"/task/"+did)
     },
     goToCreateTaskDetailsForSt(){
       		this.$router.push( '/create-task-details/'+ this.coy.id+"/st/"+this.model.st.id +"/"+this.$route.params.tid + "/0")
       },
      goToCreateTaskDetailsForStt(){
       		this.$router.push( '/create-task-details/'+ this.coy.id+"/stt/"+this.model.st.id +"/"+this.$route.params.tid + "/0")
       }, 
       goToCreateTaskDetailsForOc(){
       		this.$router.push( '/create-task-details/'+ this.coy.id+"/oc/"+this.model.oc.id +"/"+this.$route.params.tid + "/0")
       },
      goToCreateTaskDetailsForSc(){
       		this.$router.push( '/create-task-details/'+ this.coy.id+"/sc/"+this.model.sh.sc_id +"/"+this.$route.params.tid + "/0")
       },  
      goToCreateTaskDetailsForScc(){
       		this.$router.push( '/create-task-details/'+ this.coy.id+"/scc/"+this.model.sh.sc_id +"/"+this.$route.params.tid  + "/0")
       },  
     goToCreateTaskDetailsForCancelCsNewTask(){
      	this.$router.push( '/create-task-details/'+ this.coy.id+"/scc/"+this.model.sh.sc_id +"/0" + "/0")
      },
     goToEditShareTransaction(){
    	 this.$router.push( '/create-share-transaction/'+this.model.st.id+'/entity/'+this.coy.id+"/edit")  
     },
      goToEditOfficerChange(){
      	this.$router.push( '/create-officer-change/'+this.model.oc.id+'/entity/'+this.coy.id+"/edit") ; 
      } ,
    
     viewCancelScTask(){
     	this.$router.push( '/edit-task/'+this.model.sh.cancel_task_id+'/entity/'+this.coy.id);
		this.$router.go(0);
     },
     upload_reset() {
        // reset form to initial state
        this.currentStatus = UPLOAD_STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
      },
      upload_save(formData) {
        // upload data to the server
        this.currentStatus = UPLOAD_STATUS_SAVING;
		
		/*
        upload(formData)
          .then(x => {
            this.uploadedFiles = [].concat(x);
            this.currentStatus = UPLOAD_STATUS_SUCCESS;
          })
          .catch(err => {
            this.uploadError = err.response;
            this.currentStatus = UPLOAD_STATUS_FAILED;
          });
          */
          
          
         let uri = this.$base_url+'/api/v1/file_upload/task/'+ this.$route.params.tid;
         ApiService.post(uri,formData).then(response => {
            	this.currentStatus = UPLOAD_STATUS_SUCCESS;
				this.onEditTaskLoad();
				swal({
						  title: 'Uploaded',
						  text: 'The document has been uploaded.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
				})
			
		  })
          
      },
      upload_filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData();

        if (!fileList.length) return;

        // append the files to FormData
        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name);
          });

        // save it
        this.upload_save(formData);
      },
    
      emptyDeadline(){
      	this.model.deadline_date = '';
      },
      emptyScheduleDate(){
      	this.model.schedule_date = '';
      },
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
      viewPdf(){
    		//alert("PDF path:"+ this.pdf_path)
    		//window.open(this.model.documents, "_blank");  
    		this.$router.push( '/view-document/'+this.$route.params.tid+"/0");
    	},
       viewDocument(did){
       		this.$router.push( '/view-document/'+ did+"/0");
       },
        viewRequestDocument(did){
       		this.$router.push( '/view-request-document/'+ did);
       },
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
       getErrorCs(fieldName, scope) {
        	return this.errors.first(fieldName, scope)
      	},
      	
      createInvoice(){
      		this.$validator.validateAll("invoice").then(isValid => {
      		
      		 if (!isValid) {
      		 }
      		 else{
      				const vm = this;
      				swal({
						title: 'Are you sure?',
						text: 'A new billing will be created',
						type: 'warning',
						showCancelButton: true,
						confirmButtonClass: 'btn btn-success btn-fill',
						cancelButtonClass: 'btn btn-danger btn-fill',
						confirmButtonText: 'Yes, please proceed',
						buttonsStyling: false
					  }).then(function () {
							const vm_ = vm;
							if(vm.crequest){
								if(vm.crequest.id){
									vm.new_invoice.rid = vm.crequest.id;
								}
							}
							else{
								vm.new_invoice.rid = 0;
							}
							
							
							let uri = vm.$base_url+'/api/v1/tasks/create_rt_invoice/'+ vm.$route.params.tid;
							ApiService.post(uri, vm.new_invoice).then(response => {
								swal({
								  title: 'Done!',
								  text: 'A new billing has been created',
								  type: 'success',
								  confirmButtonClass: 'btn btn-success btn-fill',
								  buttonsStyling: false
								}).then(function(){
			
									vm_.onEditTaskLoad();
				
								})
				
						 })
		 
			
					  })//end swal
      
      			}
      
      		});//end validator
      },	
      sendMessage(){
      		this.$validator.validateAll("sendMsg").then(isValid => {
			  if (!isValid) {
			
			  } else {
		  			const vm = this;
		  			let uri = vm.$base_url+'/api/v1/tasks/add_req_message/'+ this.crequest.id;
		  			vm.new_message.tid = this.$route.params.tid;
		  			
					ApiService.post(uri, vm.new_message).then(response => {
					   swal({
						  title: 'Sent.',
						  text: 'The message has been send.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.onEditTaskLoad();
						})
				
					 })
			  }
      		});
      },
      uploadFile(){
      		let uploaded_file = this.$refs.new_file.files[0];
      			let formData = new FormData();
  			    formData.append('file', uploaded_file);
  			    
  			    const vm = this;
  			    
  			     let uri = this.$base_url+'/api/v1/tasks/update_req_doc/'+ this.crequest.id;
				 ApiService.post(uri,formData).then(response => {
						swal({
						  title: 'Uploaded.',
						  text: 'The file has been uploaded.',
						  type: 'success',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
						}).then(function(){
			
							vm.onEditTaskLoad();
						})//end swal
			
				  })
      	
      	
      },
      editTask() {
      	/*if(this.model.task_status == 4 && this.all_changes_completed == 2){
      			swal({
					  title: 'Error!',
					  text: "Please mark all corresponding changes as 'Complete' before marking this task as complete.",
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	}).then(function(){
			
					return;
				
				})
      	
      		return;
      	 }*/
      
      	if(this.model.task_status == 4 && !this.model.filed_datetime){
      		swal({
					  title: 'Error!',
					  text: "Please enter the filing/completion date before marking this task as completed.",
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	}).then(function(){
			
					return;
				
				})
      	
      		return;
      	}
      
      
        this.$validator.validateAll("taskMain").then(isValid => {
          if (!isValid) {
    		
  		  } else {
  		  		
  		  		const vm = this;
  		  		
  		  			swal({
            title: 'Are you sure?',
            text: 'You will be updating this task.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, please proceed',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          		let uri = vm.$base_url+'/api/v1/tasks/edit/'+ vm.$route.params.tid;
      		ApiService.post(uri, vm.model).then(response => {
      				swal({
				  title: 'Updated.',
				  text: 'The task has been updated.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					//vm_.$router.push( '/view-entity/'+vm_.coy.id)
					//swal.showLoading();
     				vm_.onEditTaskLoad();
					
				
				})
         		
     		 })
         
            
          })
  		  
  		  
    		
  		  }//end if-else
        
         
        })
      },///end validate+edit
      deleteTask: function () {
        let tid = this.$route.params.tid;
       	const vm = this;
       	
       	swal({
            title: 'Are you sure? All linked Changes will also be deleted.',
            text: 'You won\'t be able to revert this!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             	const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/tasks/delete/'+ tid;
     	  ApiService.get(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The task has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm_.$router.push( '/view-entity/'+vm_.coy.id)
				
				})
				//end swal
            })
         
            
          })
       }//end delete 
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
  
  .upload_dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

  .input-file-dropbox {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .upload_dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

  .upload_dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
</style>


